export default __webpack_public_path__ + "static/media/milestone-77.ac584541.png";